export default __webpack_public_path__ + "static/media/dudu-tassa_maliot.d7b8d4eb.mp3";